import { createContext, useContext } from "react";

export interface FieldRolloverContextValue {
  lastRolledOverFields: Record<string, unknown>;
  lastDiscardedFields: string[];
}

export const FieldRolloverContext =
  createContext<FieldRolloverContextValue | null>(null);

export const useFieldRolloverContext = (): FieldRolloverContextValue => {
  const context = useContext(FieldRolloverContext);
  if (!context) {
    throw new Error(
      "useFieldRolloverContext must be used within a FormEngineProvider"
    );
  }
  return context;
};
